module.exports = __webpack_public_path__ + "img/bj.cd64ad71.png";